import { InitiativeCreationStep } from '@app/pages/dashboard/initiative/shared/workflow'
import { NotificationFrequency } from '@schema/user'
import { InitiativeUserRole, NumberOfHomes, OwnershipMode, RentSegment } from 'schema/initiative'
import { PlotApplicationStatus } from 'schema/plot'
import { PhaseType } from '@schema/phase'

type Translation<T extends string | number | symbol> = {
  [K in T]: string
}

export const phaseTranslations: Translation<PhaseType> = {
  idea: 'Idea phase',
  location: 'Location phase',
  design: 'Desing phase',
  construction: 'Construction phase',
  living: 'Living phase',
} as const

export const plotApplicationStatusesTranslations: Translation<PlotApplicationStatus> =
  {
    applicationOpen: 'Application open',
    applicationClosed: 'Application closed',
    inPreparation: 'In preparation',
  } as const

export const initiativeUserRoleTranslation: Translation<InitiativeUserRole> = {
  owner: 'Initiativetaker',
  admin: 'Admin',
  member: 'Member',
  applicant: 'Applicant',
  follower: 'Follower',
} as const

// Note: AgeCategory, HousingTypePreference, OwnershipPreference are now schema entities
// and no longer enum types. These translations are kept for reference but not type-safe.

// Note: SpaceSizePreference and InvolvementPreference are now schema entities
// and no longer enum types. These translations are kept for reference but not type-safe.

export const notificationFrequencyTranslation: Translation<NotificationFrequency> =
  {
    weekly: 'Weekly',
    fortnightly: 'Fortnightly',
    monthly: 'Monthly',
    never: 'Never',
  } as const

export const initiativePhaseNameTranslation: Translation<PhaseType> = {
  idea: 'Idea phase',
  location: 'Location phase',
  design: 'Design phase',
  construction: 'Construction phase',
  living: 'Living phase',
} as const

export const initiativePhaseDescriptionTranslation: Translation<PhaseType> = {
  idea: "Your initiative is in a very early stage and you're looking for your crowd.",
  location:
    'You are professional group, you are registered at KVK and looking for a plot.',
  design: 'You are working on the design and might already have a plot.',
  construction:
    "You've jumped through all the hoops and now you're building your dream home.",
  living: 'You live in a realized and completed project.',
} as const

export const initiativeCreationStepTitleTranslation: Translation<InitiativeCreationStep> =
  {
    phaseSelection: 'Which phase your initiative is in?',
    livingVision: 'Living vision',
    images: 'Images',
    initiativeDetails: 'Initiative details',
    livingTogether: 'Who do you want to live with?',
    livingAmenities: 'Amenities',
    location: 'Where do you want to live?',
    contact: 'Contact',
    finish: 'Your initiative is online!',
  } as const

export const initiativeCreationStepDescriptionTranslation: Translation<InitiativeCreationStep> =
  {
    phaseSelection: null,
    livingVision:
      'Describe your idea as concretely as possible. It helps with matching.',
    images:
      'Good images make your initiative stand out. Make sure you have the right to use the images.',
    initiativeDetails: null,
    livingTogether: null,
    livingAmenities: null,
    location: null,
    contact: null,
    finish:
      'Congratulations! Your initiative is now visible on CrowdBuilding. Take the next step to make your living dream a reality.',
  } as const

export const humberOfHomesTranslation: Translation<NumberOfHomes> = {
  from2To5: '2-5',
  from6To10: '6-10',
  from11to15: '11-15',
  from16to30: '16-30',
  from31to50: '31-50',
  from51to80: '51-80',
  from81to100: '81-100',
  moreThan100: '100+',
} as const

export const ownershipModeTranslation: Translation<OwnershipMode> = {
  buy: 'Buy',
  rent: 'Rent',
  mix: 'Mix',
  dontKnow: "Don't know",
} as const

export const rentSegmentTranslation: Translation<RentSegment> = {
  social: 'Social',
  middle: 'Middle',
  freeSector: 'Free sector',
} as const
